import { html, LitElement, unsafeCSS } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../ui-sprite-svg/ui-sprite-svg';
import iconStyle from './ui-google-play-icon.css?inline';

const CName = 'ui-google-play-icon';

@customElement(CName)
export class UIGooglePlayIcon extends LitElement {
  static readonly styles = unsafeCSS(iconStyle);

  render() {
    return html`<ui-sprite-svg class="icon" .iconID=${'google-store-icon'}></ui-sprite-svg>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIGooglePlayIcon;
  }
}
